//
// Audience-Filter
//

export function audiencefilter() {
    initFilters();
}

function initFilters() {
    const audienceFilterWrapper = document.querySelector('.tx-audience-filter');
    const filterForm = document.getElementById('audienceFilter');
    const filterAudience = document.getElementById('filterAudience');
    const filterOftenSearch = document.getElementById('filterOftenSearched');
    const filterCampus = document.getElementById('filterCampus');

    if (audienceFilterWrapper) {
        filterAudience.addEventListener('change', (e) => {
            e.preventDefault();
            filterOftenSearch.selectedIndex = 0;
            filterCampus.selectedIndex = 0;
            filterResults();
        });

        filterOftenSearch.addEventListener('change', (e) => {
            e.preventDefault();
            filterCampus.selectedIndex = 0;
            filterResults();
        });

        filterCampus.addEventListener('change', (e) => {
            e.preventDefault();
            filterResults();
        });
    }
}

function filterResults() {
    const audienceFilterWrapper = document.querySelector('.tx-audience-filter');
    // get elements from swapped html
    const filterForm = document.getElementById('audienceFilter');
    const filterOftenSearch = document.getElementById('filterOftenSearched');
    const filterCampus = document.getElementById('filterCampus');

    ajaxCall(filterForm)
        .then((result) => {
            audienceFilterWrapper.outerHTML = result;
            const audienceFilterWrapperNew = document.querySelector('.tx-audience-filter');
            addEventListenersToTiles();
            initFilters();

            // make reset button visible
            document.querySelector('.filter__reset').classList.remove('d--none');
            reset(filterForm);
        })
        .catch(() => {
            audienceFilterWrapper.innerHTML = "Es ist ein Fehler aufgetreten.";
        });
}

function ajaxCall(form) {
    return new Promise((resolve, reject) => {
        let formData = new FormData(form);
        let validData = true;
        formData.forEach((value, key) => {
            if (key === "tx_audiencefilter_filter[filter1]" && typeof value === "string" && value != "" && Number.isNaN(Number(value))) {
                validData = false;
            }
            if (key === "tx_audiencefilter_filter[filter2]" && typeof value === "string" && value != "" && Number.isNaN(Number(value))) {
                validData = false;
            }
            if (key === "tx_audiencefilter_filter[campus]" && typeof value === "string" && value != "" && Number.isNaN(Number(value))) {
                validData = false;
            }
        });
        if (!validData) {
            return;
        }
        let xhr = new XMLHttpRequest();
        trackFilter();

        xhr.open('POST', form.getAttribute('action'));
        xhr.onerror = reject;
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
                resolve(xhr.responseText);
            }
        }

        xhr.send(formData);
    });
}

function addEventListenersToTiles() {
    const allElements = document.querySelectorAll('.result__list .result__item a[data-title]');
    allElements.forEach((tile) => {
        tile.addEventListener('click', (evt) => {
            let el = evt.currentTarget;
            evt.preventDefault();
            trackTile(el.getAttribute('data-title'));
            document.location.href = el.getAttribute('href');
        });
    });
}

function trackFilter() {
    if (typeof _paq != "undefined") {
        _paq.push(['trackEvent', 'Zielgruppenfilter', 'Filter', getFilterEventString()]);
    } else {
        console.log(getFilterEventString());
    }
}

function trackTile(title) {
    if (typeof _paq != "undefined") {
        _paq.push(['trackEvent', 'Zielgruppenfilter', 'Filter und Klick auf Kachel', getFilterEventString()  + " --> " + title]);
    } else {
        console.log(getFilterEventString() + " --> " + title);
    }
}

function getFilterEventString() {
    let filterAudience = document.getElementById('filterAudience');
    let filterOftenSearched = document.getElementById('filterOftenSearched');
    let filterCampus = document.getElementById('filterCampus');

    let trackEvent = filterAudience.options[filterAudience.selectedIndex].getAttribute('data-label');
    if (filterOftenSearched.value) {
        trackEvent = trackEvent + "  > " + filterOftenSearched.options[filterOftenSearched.selectedIndex].getAttribute('data-label');
    }
    if (filterCampus.value) {
        trackEvent = trackEvent + "  > " + filterCampus.options[filterCampus.selectedIndex].getAttribute('data-label');
    }

    return trackEvent;
}

function reset(form) {
    const resetBtn = document.querySelector('.btn--reset');
    const audienceFilterWrapper = document.querySelector('.tx-audience-filter');

    resetBtn.addEventListener('click', (e) => {
        e.preventDefault();
        let xhr = new XMLHttpRequest();

        xhr.open('POST', form.getAttribute('action'));
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
                audienceFilterWrapper.outerHTML = xhr.responseText;
                audiencefilter();
            }
        }
        xhr.send("");
    });
}
